import { ICollection } from '_/types/collections/collections.types';
import { Select, Form } from 'antd';
import React, { ChangeEvent, useMemo } from 'react';

interface FlowDefinitionProps {
  collections: ICollection[];
  handleFieldChange: (event: ChangeEvent<HTMLInputElement> | { target: { name: string; value: any } }) => void;
  hideLabel?: boolean;
  isEditMode: boolean;
}

function FlowDefinition({ collections, handleFieldChange, hideLabel, isEditMode }: FlowDefinitionProps) {
  const collectionOptions = useMemo(
    () =>
      collections?.map((collection) => ({
        label: collection.name,
        value: collection.id,
        key: collection.name,
      })) || [],
    [collections],
  );

  return (
    <Form.Item
      name="collectionId"
      label={hideLabel ? undefined : 'Collection'}
      rules={[
        {
          required: true,
          message: 'Please select a collection',
        },
      ]}
    >
      <Select
        id="definition"
        onChange={(value) => handleFieldChange({ target: { name: 'collectionId', value: value } } as any)}
        disabled={isEditMode}
        options={collectionOptions}
        placeholder="Select a collection"
      />
    </Form.Item>
  );
}

export default FlowDefinition;
